/** @format */

import { memo } from 'react'
import { CopyBlock, ocean } from 'react-code-blocks'

import styles from 'dir/styles/courses.module.css'

export const _2 = memo(() => (
  <section className={styles.section}>
    <h2 className={styles.h2}>1 - Подключение скрипта</h2>
    <p className={styles.description}>
      Чтобы добавить скрипт на веб-страницу, в HTML-файле используется тег <code className={styles.code}>script</code>,
      в атрибуте <code className={styles.code}>src</code> которого указываем ссылку на внешний JavaScript-файл.
    </p>
    <p className={styles.description}>Чтобы подключить JavaScript из внешнего файла:</p>
    <ul className={styles.list}>
      <li className={styles.list__item}>
        Создайте файл с расширением <code className={styles.code}>.js</code> и поместите его в подпапку{' '}
        <code className={styles.code}>js</code>. Размещение JavaScript файла в папке{' '}
        <code className={styles.code}>js</code> не требуется, однако это хорошая практика.
      </li>
      <li className={styles.list__item}>
        Затем укажите путь к файлу скрипта в атрибуте <code className={styles.code}>src</code> тега{' '}
        <code className={styles.code}>script</code>.
      </li>
    </ul>
    <CopyBlock
      text={`<!DOCTYPE html>
<html lang="en">
      <head>
          <meta charset="UTF-8" />
          <title>JavaScript is fun!</title>
      </head>

      <body>
          <!-- контент -->
          <script src="js/script.js"></script>
      </body>
</html>`}
      language="html"
      showLineNumbers
      theme={ocean}
    />
    <p className={styles.description}>
      При отображении HTML-документа, некоторое время может отображаться пустая страница. Дело в том, что фаза
      рендеринга страницы приостаналивается до тех пор, пока не будет полностью загружен скрипт (если он подключен в{' '}
      <code className={styles.code}>head</code>). Чтобы этого избежать, необходимо подключать скрипт перед закрывающим
      тегом <code className={styles.code}>body</code>, после всего содержимого, как показано в примере.
    </p>

    <section className={styles.subsection}>
      <h2 className={styles.h2}>2 - Несколько скриптов</h2>
      <p className={styles.description}>
        При подключении нескольких JavaScript-файлов к странице, интерпретатор обрабатывает их в том порядке, в котором
        они указаны в HTML-файле.
      </p>
      <CopyBlock
        text={`<script src="js/script-1.js"></script>
<script src="js/script-2.js"></script>`}
        language="html"
        showLineNumbers
        theme={ocean}
      />
      <p className={styles.description}>
        Браузер загружает и отображает HTML постепенно. Если браузер видит тег{' '}
        <code className={styles.code}>script</code>, то по стандарту он обязан сначала выполнить его, и только потом
        обработать остальной код HTML-файла. Поэтому, интерпретатор будет последовательно обрабатывать файлы{' '}
        <code className={styles.code}>script-1.js</code> и <code className={styles.code}>script-2.js</code>.
      </p>
    </section>
  </section>
))
